import { css } from '@emotion/css';

export const shadowCommon = 'absolute top-0 h-full w-[9rem] z-10 pointer-events-none pt-8';
export const shadowLeft = css`
  left: 0;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
`;
export const shadowRight = css`
  right: 0;
  background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
`;
export const shadowWidth = (isMobile: boolean) => (isMobile ? 'w-[3.2rem]' : 'w-[9rem]');
